export interface GetProjectRegionListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetProjectRegionListPagingAndFilterResponseData
}

export interface GetProjectRegionListPagingAndFilterResponseData {
    items: GetProjectRegionListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetProjectRegionListPagingAndFilterResponseItem {
    projectRegionId: string
    companyId: string
    countryId: string
    countyId: string
    districtId: string
    neighborhoodId: any
    projectId: string
    regionId: string
    isFarPoint: boolean
    description: string
    countryName: string
    countyName: string
    districtName: string
    neighborhoodName: any
    projectName: string
    regionName: string
    projectRegionCarryTypes: GetProjectRegionListPagingAndFilterResponseProjectRegionCarryType[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetProjectRegionListPagingAndFilterResponseProjectRegionCarryType {
    projectRegionCarryTypeId: string
    projectRegionId: string
    carryTypeId: string
    carryTypeName: string
    carryTypeKey: any
}

export const initialGetProjectRegionListPagingAndFilterResponseData: GetProjectRegionListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}